export default function() {
	return {
		images: [],
		observer: null,
		containerHeight: 0,
		containerTop: 0,
		isInView: false,
		offsets: { // in percentages
			alveole1: 4.5,
			alveole2: 5.5,
			intercalaire: 3,
			palette: 12, //19
		},

		init() {
			this.setupIntersectionObserver();

			// Ajouter les gestionnaires d'événements
			window.addEventListener('scroll', this.handleScroll.bind(this));
			window.addEventListener('resize', this.handleResize.bind(this));

			// Initialiser les positions
			this.handleResize();
			this.handleScroll();
		},

		initVars() {
			// Trouver tous les éléments li
			const items = this.$el.querySelectorAll('li');
			const bodyRect = document.body.getBoundingClientRect();
			const containerRect = this.$el.getBoundingClientRect();

			this.containerHeight = this.$el.offsetHeight;
			this.containerTop = containerRect.top - bodyRect.top;

			let total_offset = 0;

			// Initialiser le tableau d'images
			let zindex = 10;
			this.images = Array.from(items).map((item, index) => {
				const img = item.querySelector('img[data-type="'+item.dataset.type+'"]');
				if (img) {
					let linked = item.querySelectorAll('img:not([data-type="'+item.dataset.type+'"])');
					if (linked.length > 0) {
						for (let i = 0; i < linked.length; i++) {
							linked[i].style.transform = `translateY(0px)`;
							linked[i].style.zIndex = zindex - (linked.length - 1) + i; // zindex in reverse order
							zindex--;
						}
					}

					img.style.transform = `translateY(0px)`;
					img.style.zIndex = zindex;
					zindex--;

					let offset = this.offsets[item.dataset.type] / 100 * img.offsetHeight;
					total_offset += offset;

					return {
						el: img,
						type: item.dataset.type,
						top: img.offsetTop + img.offsetParent.offsetTop, // position top de l'image dans le container, on utilise offsetTop à la place de getBoundingClientRect pour que le transform ne soit pas pris en compte
						height: img.offsetHeight,
						offset: total_offset, // décalage entre chaque image
						linked: linked.length > 0 ? linked : null
					};
				}
				return null;
			}).filter(img => img !== null);
		},

		setupIntersectionObserver() {
			this.observer = new IntersectionObserver((entries) => {
				this.isInView = entries[0].isIntersecting;
				if (this.isInView && !this.wasInView) {
					this.initVars();
				}
				this.wasInView = this.isInView;
			}, {
				root: null,
				rootMargin: '100px 0px', // Marge pour déclencher l'observation avant que l'élément soit complètement visible
				threshold: 0.1 // Déclenche dès que 10% de l'élément est visible
			});

			this.observer.observe(this.$el);
		},

		handleScroll() {
			requestAnimationFrame(() => {
				if (!this.isInView) return;
				this.updateImagesPosition();
			});
		},

		handleResize() {
			// Mettre à jour les dimensions
			this.containerHeight = this.$el.offsetHeight;
			this.updateImagesPosition();
		},

		updateImagesPosition() {
			if (!this.images.length) return;

			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const windowHeight = window.innerHeight;
			const windowHalf = windowHeight / 2;

			this.images.forEach((image, i) => {
				const { el, type, top, height, offset, linked } = image;

				let absoluteTop = top + this.containerTop;

				let translateY = scrollTop - absoluteTop; // le haut de l'image suit le haut de la page au scroll
				translateY+=  windowHalf; // on le décale au milieu de la page (avec un offset pour qu'il soit un peu plus bas)
				translateY-= height / 2; // on centre l'image
				translateY+= offset; // On ajoute l'offset entre chaque image pour l'effet d'empilement

				// On s'arrête à la position initiale de l'image (moins sa moitié pour la centrer)
				const stopPosition = 0 - (height / 4);
				if (translateY > stopPosition) {
					translateY = stopPosition;
				}

				// On ne dépasse pas le haut du container
				if (translateY <= (top * -1) + offset) {
					translateY = (top * -1) + offset;
				}

				if (linked) {
					let linkedOffset = 0;
					for (let i = 0; i < linked.length; i++) {
						linkedOffset+= this.offsets[linked[i].dataset.type] / 100 * linked[i].offsetHeight;
						let linkedTranslateY = translateY - linkedOffset;
						linked[i].style.transform = `translateY(${linkedTranslateY}px)`;

						// opacity 0 at translateY = stopPosition, 1 at translateY = stopPosition-height
						let opacity = (translateY - stopPosition) / (stopPosition - (height/2));
						linked[i].style.opacity = opacity;
					}
				}

				el.style.transform = `translateY(${translateY}px)`;
			});
		}

	};
}
